import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { LayoutSpinner } from '@/bundle/Layouts/styles';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { ACTIVATION_TOKEN_INVALID_RESPONSE } from '@/api/const';
import { getSetPasswordLinkExpiredPath } from '@/bundle/Auth/InviteUserFlow/SetPasswordLinkExpiredPage/path/path';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { getSetInitialPasswordPath } from '@/bundle/Auth/InviteUserFlow/SetInitialPasswordPage/path/path';
import { validateAuthTotp } from './api';
import { ValidateAuthTotpPayload } from '@/api/v1/users/authValidateTotpApi';
import { showSnackbarResponseError } from '@/helpers/helpers';

export const SetInitialPasswordValidateTotpPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isValidatingTotp, setIsValidatingTotp] = useState(true);

  const { mutate } = useMutation({
    mutationKey: ['validate_auth_totp'],
    mutationFn: (payload: ValidateAuthTotpPayload) => {
      return validateAuthTotp(payload);
    },
    onSuccess(response) {
      if (response?.error) {
        const errorContent = getResponseError(response?.error);

        if (errorContent === ACTIVATION_TOKEN_INVALID_RESPONSE) {
          return navigate(getSetPasswordLinkExpiredPath());
        }

        return showSnackbarResponseError(response?.error);
      }

      const token = searchParams.get('token');
      const userId = searchParams.get('user_id');

      navigate(getSetInitialPasswordPath(userId, token));
    },
    onSettled: () => {
      setIsValidatingTotp(false);
    },
  });

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('user_id');
    const tokenType = searchParams.get('token_type');

    if (!token || !userId) {
      navigate(getLoginPath());

      return;
    }

    const payload = {
      token,
      user_id: userId,
      token_type: tokenType,
    };

    mutate(payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isValidatingTotp) {
    return (
      <AuthLayout>
        <LayoutSpinner />
      </AuthLayout>
    );
  }

  return null;
};
